export const GET_DISPLAYPREFERENCE = 'GET_DISPLAYPREFERENCE'
export const SAVE_DISPLAYPREFERENCE = 'SAVE_DISPLAYPREFERENCE'



// WEBPACK FOOTER //
// ./src/actionTypes/DisplaySettings/DisplaySettings.js